
import { defineComponent, ref, computed } from 'vue'
import { usePackageModule, Package } from '@/modules/packages'
import { useRoute } from 'vue-router'
import { PackagesRouteNames } from '@/router/routes-names'
import { SimpleSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo, storeFormModel } from '@/modules/_shared/forms'
import PackagesList from '@/components/packages/packages-list.vue'

export default defineComponent({
    name: 'view-packages-packages',
    components: { PackagesList },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    setup (props) {
        const { packages } = usePackageModule()
        const route = useRoute()

        const packageRows = computed(() => {
            return packages.value.map((packageItem: Package) => {
                return {
                    ...packageItem,
                    isActive: packageItem.status === 'active'
                }
            })
        })

        const restoredFilter = { value: '' } as SimpleSearchFilter
        if (props.restoreFilters) {
            restoreFormModelTo(restoredFilter, FormModelCacheTag.PACKAGES_LIST_FILTERS)
        }
        const filter = ref<string>(restoredFilter.value ?? '')

        const filteredPackages = computed(() => {
            storeFormModel({ value: filter.value }, FormModelCacheTag.PACKAGES_LIST_FILTERS)

            if (filter.value === null || filter.value === '') {
                return packageRows.value
            }

            const regexp = new RegExp(filter.value, 'i')
            return packageRows.value.filter(pack => regexp.test(`${pack.name} ${pack.code}`))
        })

        return {
            packages,
            filteredPackages,
            PackagesRouteNames,
            filter,
            route
        }
    }
})
